<template>
  <!-- ↓ footer -->
  <footer class="l-footer">
    <ul class="l-footer__lists">
      <li class="l-footer__list">
        <a
          v-if="fluxContactUsUrl"
          class="l-footer__list-link"
          :href="fluxContactUsUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ t('common.contactUs') }}</a
        >
      </li>
      <li class="l-footer__list" v-if="fluxPrivacyPolicyUrl">
        <a
          class="l-footer__list-link"
          :href="fluxPrivacyPolicyUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ t('common.privacyPolicy') }}</a
        >
      </li>
      <li class="l-footer__list" v-if="fluxTermsUrl">
        <a
          class="l-footer__list-link"
          :href="fluxTermsUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ t('common.termsOfService') }}</a
        >
      </li>
      <li class="l-footer__list">
        <a
          class="l-footer__list-link"
          :href="fluxCorporateWebsiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ t('common.corporateWebsite') }}</a
        >
      </li>
    </ul>
    <small class="l-footer__copyright">Copyright 2020 RUN.EDGE</small>
  </footer>
  <!-- ↑ footer -->
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import Const from '@/util/Const'

export default defineComponent({
  name: 'Footer',
  setup() {
    const { locale } = useI18n()
    const fluxCorporateWebsiteUrl = computed(() => {
      return Const.corporateUrl
    })
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    const fluxContactUsUrl = computed(() => {
      const foreignUrl =
        locale.value === 'es'
          ? `${process.env.VUE_APP_FLUX_FOREIGN_SUPPORT_PAGE_BASE_URL}/es${process.env.VUE_APP_FLUX_FOREIGN_CONTACT_US_PAGE_PATH}`
          : process.env.VUE_APP_FLUX_FOREIGN_SUPPORT_PAGE_BASE_URL +
            process.env.VUE_APP_FLUX_FOREIGN_CONTACT_US_PAGE_PATH
      return locale.value === 'ja' ? process.env.VUE_APP_FLUX_CONTACT_US_PAGE_URL : foreignUrl
    })
    return {
      fluxCorporateWebsiteUrl,
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      fluxContactUsUrl,
      ...useI18n(),
    }
  },
})
</script>
